/// <summary>
/// Author: -
/// </summary>
export class ConfigEnum {
    static _LANGUAGE = "language";
    static _BEARER_TOKEN = "token";
    static _USER_DATA = "userData";
}